'use strict'; // http://www.ecma-international.org/ecma-262/6.0/#sec-object.is

var numberIsNaN = function numberIsNaN(value) {
  return value !== value;
};

module.exports = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }

  if (a === b) {
    return true;
  }

  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }

  return false;
};